import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import {Grid} from '@mui/material';
import {useSelector} from 'react-redux';
import {RootState} from '../../../redux/store';
import {ILoanCard} from './ILoanCard';
import './loanCard.css';

type TStatus = 'other' | 'Assigned' | 'Settled' | 'CanceledBySetad';

const statusColors: Record<TStatus, {light: string; dark: string}> = {
    other: {light: '#FFE8C5', dark: '#434343'},
    Assigned: {light: '#D3EBD5', dark: '#434343'},
    Settled: {light: '#D7DBEC', dark: '#434343'},
    CanceledBySetad: {light: '#FBE4E7', dark: '#434343'},
};
const statusBorderColors: Record<TStatus, string> = {
    other: '#FAD194',
    Assigned: '#B6E0B8',
    Settled: '#BCC3F1',
    CanceledBySetad: '#F4BDC5',
};

export default function LoanCard({
    status,
    financialProvider,
    price,
    onClick,
    insallmentStep,
    statusTitle,
    financialSupplierLogoUrl,
}: ILoanCard) {
    const theme = useSelector((state: RootState) => state.theme);

    return (
        <Grid
            container
            xs={12}
            className={` p-3 mb-4`}
            sx={{
                border: `1.5px solid ${theme === 'dark' ? '#434343' : '#E6E9F4'}`,
                borderRadius: '8px',
                boxShadow:
                    theme === 'dark'
                        ? '2px 2px 10px rgba(0,0,0,0.4)'
                        : '2px 2px 10px rgba(0, 0, 0, 0.1)',
                background:
                    theme === 'dark'
                        ? statusColors[status as TStatus]?.dark
                        : `${statusColors[status as TStatus]?.light ?? statusColors['other'].light}`,
                position: 'relative',
            }}
            onClick={() => onClick!()}
        >
            <Grid
                item
                xs={12}
                textAlign={'center'}
                className="!pb-2 !pr-2 !pl-2"
                container
                sx={{position: 'relative', zIndex: '2'}}
            >
                <Grid
                    sx={{
                        paddingRight: '.3em',
                        fontWeight: 'normal',
                        fontSize: '.8rem',
                        color:
                            theme === 'dark'
                                ? `${statusBorderColors[status as TStatus] ?? statusBorderColors['other']}`
                                : 'var(--secondary-text-color)',
                    }}
                    xs={11}
                    textAlign={'right'}
                >
                    {statusTitle}
                </Grid>
                <Grid xs={1} textAlign={'left'}>
                    <MoreHorizIcon
                        sx={{
                            color:
                                theme === 'dark'
                                    ? '#fff'
                                    : 'var(--tirnary-text-color)',
                        }}
                    />
                </Grid>
            </Grid>
            <Grid
                className="!px-2"
                xs={12}
                sx={{
                    marginBottom: '.5rem',
                    color: theme === 'dark' ? '#fff' : undefined,
                }}
            >
                <b style={{fontSize: '1.3rem'}}>{price.toLocaleString()}</b>{' '}
                <span className="mr-1 text-xs">ریال</span>
            </Grid>
            <Grid
                item
                container
                xs={12}
                textAlign={'center'}
                className={`!px-2 !py-3   `}
                sx={{
                    margin: 'auto',
                    borderRadius: '5px',
                    boxShadow:
                        theme === 'dark'
                            ? 'inset 0 2px 4px rgba(0,0,0,0.3)'
                            : 'inset 0 2px 4px rgba(0, 0, 0, 0.1)',
                    background:
                        statusBorderColors[status as TStatus] ??
                        statusBorderColors['other'],
                }}
            >
                <Grid
                    sx={{display: 'flex', alignItems: 'center', zIndex: '2'}}
                    xs={10}
                    textAlign={'right'}
                >
                    <b className="ml-1 text-[.9rem]">{financialProvider}</b>
                    <span className="text-xs">({insallmentStep})</span>
                </Grid>
                <Grid xs={2} sx={{display: 'flex', justifyContent: 'left'}}>
                    <img
                        src={financialSupplierLogoUrl}
                        style={{
                            objectFit: 'contain',
                            border: `2px solid ${statusBorderColors[status as TStatus] ?? statusBorderColors['other']}`,
                            borderRadius: '50%',
                            padding: '5px',

                            width: '2.12rem',
                            height: '2.12rem',
                            filter:
                                theme === 'dark'
                                    ? 'brightness(0.8)'
                                    : undefined,
                        }}
                        className="bg-white"
                    />
                </Grid>
            </Grid>
        </Grid>
    );
}
